var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "tandem" }, [
    _c(
      "div",
      { staticClass: "tandem-search" },
      [
        _c("TandemFiltersComponent", {
          on: { "set-filter": _vm.setTandemFilter },
        }),
        _vm.isNotFoundData
          ? _c("div", { staticClass: "tandem-no-results" }, [
              _c("span", { staticClass: "lf-icon-document" }),
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.texts.notResults) },
              }),
            ])
          : _vm.isLoadingData
          ? _c(
              "div",
              { staticClass: "tandem-no-results" },
              [_c("SpinnerLayerComponent", { staticClass: "spinner-layer" })],
              1
            )
          : _c(
              "div",
              { staticClass: "tandem-items" },
              [
                _vm._l(_vm.tandemData, function (data) {
                  return [
                    _c("div", { staticClass: "tandem-item" }, [
                      _c("div", { staticClass: "tandem-lead-in" }, [
                        _c(
                          "div",
                          { staticClass: "tandem-vertical-separator" },
                          [
                            _c("div", { staticClass: "tandem-header" }, [
                              _c("div", { staticClass: "tandem-titles" }, [
                                _c("div", {
                                  staticClass: "tandem-title",
                                  domProps: {
                                    innerHTML: _vm._s(data.metadata.name),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.openFile(data)
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "tandem-sub-title" },
                                  [
                                    _c("span", {
                                      class: _vm.getEntity(
                                        data.metadata.entityType
                                      ).icon,
                                    }),
                                    _c("router-link", {
                                      staticClass: "tandem-sub-title-text",
                                      attrs: { to: _vm.getEntityURL(data) },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          `${data.metadata.entityDescription} ${data.metadata.entityName}`
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "tandem-actions e-toolbar-right",
                                },
                                [
                                  _c("div", { staticClass: "tandem-button" }, [
                                    _c(
                                      "div",
                                      { staticClass: "tandem-button-cover" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.openFile(data)
                                              },
                                            },
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "e-btn-icon lf-icon-visible e-icons",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "tandem-button" }, [
                                    _c(
                                      "div",
                                      { staticClass: "tandem-button-cover" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.downloadFile(data)
                                              },
                                            },
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "e-btn-icon lf-icon-download e-icons",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "tandem-summary" }, [
                              _c("img", {
                                staticClass: "quote-svg",
                                attrs: {
                                  src: require("@/assets/images/svg/quote.svg"),
                                  alt: "Quote icon",
                                },
                              }),
                              _c("div", {
                                staticClass: "tandem-summary-text",
                                domProps: {
                                  innerHTML: _vm._s(data.highlights[0]),
                                },
                              }),
                            ]),
                            data.metadata.principalDescriptors &&
                            data.metadata.principalDescriptors.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "tandem-principal-descriptors",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tandem-descriptors" },
                                      _vm._l(
                                        data.metadata.principalDescriptors.slice(
                                          0,
                                          5
                                        ),
                                        function (pdesc) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tandem-principal-descriptors-text",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.addDescriptor(
                                                    1,
                                                    pdesc
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(pdesc.toUpperCase())
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            data.metadata.secondaryDescriptors &&
                            data.metadata.secondaryDescriptors.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "tandem-secondary-descriptors",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tandem-descriptors" },
                                      _vm._l(
                                        data.metadata.secondaryDescriptors.slice(
                                          0,
                                          8
                                        ),
                                        function (sdesc) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tandem-secondary-descriptors-text",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.addDescriptor(
                                                    2,
                                                    sdesc
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  sdesc
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    sdesc.slice(1)
                                                )
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "tandem-item-separator" }),
                  ]
                }),
              ],
              2
            ),
        _c("OpenFileComponent", { ref: "openFileComponent" }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tandem-footer" },
      [
        _vm.showPaginator
          ? _c("PaginationComponent", {
              staticClass: "pagination-component",
              style: _vm.cssVars,
              attrs: {
                totalPages: _vm.totalPages,
                maxVisibleButtons: _vm.maxVisibleButtonsPage,
                currentPage: _vm.getPaginationData.numPage + 1,
              },
              on: { pageChanged: _vm.onPageChanged },
            })
          : _vm._e(),
        _c("div", { staticClass: "select-wrapper" }, [
          _c(
            "div",
            { staticClass: "tandem-select-num-recs" },
            [
              _vm.showPaginator
                ? _c("v-select", {
                    attrs: {
                      items: _vm.numRecsPerPage,
                      "append-icon": _vm.icons.arrowDown,
                      "menu-props": { contentClass: "tandem-paginator-list" },
                    },
                    on: { change: _vm.refreshSearch },
                    model: {
                      value: _vm.getPaginationData.recsPerPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.getPaginationData, "recsPerPage", $$v)
                      },
                      expression: "getPaginationData.recsPerPage",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.showPaginator
            ? _c("div", { staticClass: "recs-per-page" }, [
                _vm._v(_vm._s(_vm.texts.recsPerPage)),
              ])
            : _vm._e(),
        ]),
        _vm.showPaginator
          ? _c("div", { staticClass: "tandem-page-info" }, [
              _vm._v(_vm._s(_vm.numPagesLiteral)),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }